
import { Text, View } from '@react-pdf/renderer'
import React from 'react'
import { shippingDataStyles } from './shippingDataStyles';
import { defaultTheme } from '../../../../theme/theme';

const { shippingData } = shippingDataStyles();


const ShippingConcept = ({ title, data, isFirst, isLast }: any) => {

    let primaryColor = defaultTheme.palette.primary.main
    return (
        <View style={shippingData.subContainer}>
            <View style={[shippingData.titleContainer,{ backgroundColor: primaryColor}]}>
                <Text style={[shippingData.title, {color: 'white'}]}>{title || ' '}</Text>
            </View>
            <View style={shippingData.dataContainer}>
                <Text style={shippingData.data}>{data || ' '}</Text>
            </View>
        </View>
    );
};


export const ShippingData = ({data,showTranslatedText}:any) => {
    return (

        <View fixed style={shippingData.container}>
            <ShippingConcept title={showTranslatedText("reports.salesInvoicePdf.shippingData.customerPO")} data={data.dataInvoiceGeneral.purchase_order || ' '} isFirst={true}/>
            <ShippingConcept title={showTranslatedText("reports.salesInvoicePdf.shippingData.shipVia")} data={data.dataShippingTracking.track_id || ' '} />
            <ShippingConcept title={showTranslatedText("reports.salesInvoicePdf.shippingData.trackingNumber")} data={data.dataShippingTracking.track_id || ' '} />
            <ShippingConcept title={showTranslatedText("reports.salesInvoicePdf.shippingData.dueDate")} data={data.dataInvoiceGeneral.payment_due_date || ' '}  isLast={true}/>
        </View>
    )
}
